import { STEPS, CONTACT } from "../data";
import { Reveal, SectionLabel } from "./Reveal";
import { ArrowRight, ArrowUpRight, Phone } from "lucide-react";
import { useQuote } from "../context/QuoteContext";

export const Process = () => {
  const { openQuote } = useQuote();
  return (
    <section
      id="werkwijze"
      className="relative bg-background py-24 sm:py-32"
      data-testid="process"
    >
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-10">
        <div className="max-w-2xl mb-16">
          <SectionLabel>Werkwijze</SectionLabel>
          <Reveal>
            <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight text-ink leading-[1.02]">
              In 3 heldere stappen naar een schoon resultaat
            </h2>
          </Reveal>
        </div>

        <div className="grid md:grid-cols-3 gap-6 lg:gap-8">
          {STEPS.map((s, i) => (
            <Reveal key={s.n} delay={i * 0.12}>
              <div
                data-testid={`step-${i}`}
                className="group relative h-full rounded-3xl border border-border bg-card p-8 transition-[transform,box-shadow] duration-500 hover:-translate-y-1.5 hover:shadow-[0_20px_50px_rgba(2,43,91,0.10)]"
              >
                <div className="flex items-center justify-between">
                  <span className="font-display text-7xl font-bold text-navy/10 transition-colors duration-500 group-hover:text-teal/20">
                    {s.n}
                  </span>
                  {i < STEPS.length - 1 && (
                    <ArrowRight className="h-6 w-6 text-teal/40 hidden md:block" />
                  )}
                </div>
                <h3 className="mt-4 font-display text-2xl font-bold tracking-tight text-ink">
                  {s.title}
                </h3>
                <p className="mt-3 text-muted-foreground leading-relaxed text-sm">
                  {s.text}
                </p>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.1}>
          <div className="mt-12 flex flex-col sm:flex-row items-center justify-center gap-4">
            <button
              onClick={() => openQuote()}
              data-testid="process-cta"
              className="group inline-flex items-center gap-2 rounded-full bg-teal px-7 py-4 font-semibold text-white transition-transform duration-300 hover:-translate-y-0.5"
            >
              Gratis offerte aanvragen
              <ArrowUpRight className="h-5 w-5 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
            </button>
            <a
              href={CONTACT.phoneHref}
              data-testid="process-phone"
              className="inline-flex items-center gap-2 rounded-full border border-border px-7 py-4 font-semibold text-ink transition-colors duration-300 hover:bg-secondary"
            >
              <Phone className="h-5 w-5 text-teal" />
              Of bel direct voor persoonlijk advies
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default Process;
